import React, { useState } from 'react'
import { TextField, Button } from '@material-ui/core'
import { Form, Field } from 'react-final-form'
import { getPriceData } from './lib/fetch'
import Response from './Response'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  margin: 0 -0.5rem;
  & > * {
    margin: 0 0.5rem;
  }
`

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
  },
})

const PriceForm = ({ classes }) => {
  const [response, setResponse] = useState(null)

  const handleSubmit = async values => {
    localStorage.setItem('password', values.password)
    const res = await getPriceData(values)
    setResponse(res.data)
  }
  return (
    <Paper className={classes.root} elevation={0}>
      <Form
        initialValues={{
          password: localStorage.getItem('password'),
        }}
        onSubmit={handleSubmit}
        render={({ handleSubmit, submitting }) => (
          <form onSubmit={handleSubmit}>
            <Container>
              <Field
                name="sku"
                render={({ input, meta }) => (
                  <div>
                    <TextField label="SKU" {...input} margin="normal" />
                  </div>
                )}
              />
              <Field
                name="ean"
                render={({ input, meta }) => (
                  <div>
                    <TextField label="EAN" {...input} margin="normal" />
                  </div>
                )}
              />
              <Field
                name="keywords"
                render={({ input, meta }) => (
                  <div>
                    <TextField
                      label="Keywords"
                      {...input}
                      margin="normal"
                      autocomplete="off"
                    />
                  </div>
                )}
              />
              <Field
                name="password"
                render={({ input, meta }) => (
                  <div>
                    <TextField
                      // type="password"
                      label="Passwort"
                      {...input}
                      margin="normal"
                      autocomplete="off"
                    />
                  </div>
                )}
              />
            </Container>
            <div>
              <Button variant="contained" color="primary" type="submit">
                {submitting ? 'Bitte warten' : 'Preis abfragen'}
              </Button>
            </div>
          </form>
        )}
      />
      {response && <Response response={response} />}
    </Paper>
  )
}

export default withStyles(styles)(PriceForm)
